// src/utils/categoriesConfig.js
export const MAIN_CATEGORIES = [
  { value: 'Day-Time Activities', label: { TH: 'กิจกรรมกลางวัน', EN: 'Day-Time Activities', CN: '日间活动' } },
  { value: 'Night-Time Activities', label: { TH: 'กิจกรรมกลางคืน', EN: 'Night-Time Activities', CN: '夜间活动' } },
  { value: 'Promotion/Coupons', label: { TH: 'โปรโมชั่น/คูปอง', EN: 'Promotion/Coupons', CN: '促销/优惠券' } },
  { value: 'Food Review', label: { TH: 'รีวิวอาหาร', EN: 'Food Review', CN: '美食评论' } },
  { value: 'Service Review', label: { TH: 'รีวิวบริการ', EN: 'Service Review', CN: '服务评论' } },
  { value: 'Product Review', label: { TH: 'รีวิวสินค้า', EN: 'Product Review', CN: '产品评论' } },
  { value: 'Tickets', label: { TH: 'ตั๋วเข้างาน', EN: 'Tickets', CN: '门票' } },
  { value: 'Small Group Activities', label: { TH: 'กิจกรรมกลุ่มเล็ก', EN: 'Small Group Activities', CN: '小组活动' } },
  { value: 'Creators/Reviewers', label: { TH: 'ผู้สร้างสรรค์/นักรีวิว', EN: 'Creators/Reviewers', CN: '创作者/评论家' } },
];

export const NAV_TABS = [
  { id: 'Explore',   label: { TH: 'สำรวจ', EN: 'Explore', CN: '探索' },
    sources: ['events', 'reviews', 'venues'], excludeCategories: ['Promotion/Coupons'], categoryFilter: null },
  { id: 'Events',    label: { TH: 'กิจกรรม', EN: 'Events', CN: '活动' },
    sources: ['events'], excludeCategories: ['Promotion/Coupons'], categoryFilter: null },
  { id: 'Reviews',   label: { TH: 'รีวิว', EN: 'Reviews', CN: '评论' },
    sources: ['reviews'], excludeCategories: [], categoryFilter: null },
  { id: 'Places',    label: { TH: 'สถานที่', EN: 'Places', CN: '地点' },
    sources: ['venues'], excludeCategories: [], categoryFilter: null },
  { id: 'Promotion', label: { TH: 'โปรโมชั่น', EN: 'Promotion', CN: '促销' },
    sources: ['events'], excludeCategories: [], categoryFilter: 'Promotion/Coupons' },
];